<template>
  <div>
    <!--  -->
    <el-form>
      <el-form-item :error="errorMessage" style="margin-bottom: 7px">
        <el-input
          type="textarea"
          :autosize="true"
          readonly
          v-model="userNames"
          :disabled="disabled"
          @focus="showDialog()"
        ></el-input>
      </el-form-item>
    </el-form>

    <!--  -->
    <el-dialog
      title="请选择人员"
      :visible.sync="dialogVisible"
      append-to-body
      @close="closeUserDialog"
      width="60%"
    >
      <template v-loading="dialogLoading">
        <el-row>
          <el-form inline>
            <el-form-item label="姓名">
              <el-input v-model="realName"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model="phone"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="searchForm">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row gutter="10">
          <el-col span="6">
            <div>
              <el-tabs type="border-card">
                <el-tab-pane label="部门">
                  <el-tree
                    v-loading="treeLoading"
                    :data="departmentTreeList"
                    :props="defaultProps"
                    @node-click="handleDeptNodeClick"
                  ></el-tree>
                </el-tab-pane>
                <el-tab-pane label="班组">
                  <el-tree
                    v-loading="treeLoading"
                    :data="groupTreeList"
                    :props="defaultProps_"
                    @node-click="handleGroupNodeClick"
                  ></el-tree>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-col>
          <el-col span="7">
            <div class="pane">
              <div>全选</div>
              <div
                item="for-select"
                name="item-for-select"
                style="cursor: pointer; padding: 1rem 1rem"
                @click="selectUserHandler($event)"
                v-for="(item, index) in dataForUserSelect"
                :key="index"
                :label="item.realName"
                :value="item.id"
              >
                {{ item.realName }}
              </div>
            </div>
          </el-col>
          <el-col span="4">
            <div style="text-align: center; margin: 20px 0">
              <el-tag type="info" v-if="single"> 只能选择一人 </el-tag>
            </div>
            <div style="text-align: center; margin: 20px 0">
              <el-button
                type="primary"
                @click="moveLeftAction"
                :disabled="moveLeftDisabled"
                >左移</el-button
              >
            </div>
            <div style="text-align: center; margin: 20px 0">
              <el-button
                type="primary"
                @click="moveRightAction"
                :disabled="moveRightDisabled"
                >右移</el-button
              >
            </div>
          </el-col>
          <el-col span="7">
            <div class="pane">
              <div>全选</div>
              <div
                item="for-select"
                name="item-for-selected"
                style="cursor: pointer; padding: 1rem 1rem"
                @click="selectedUserHandler($event)"
                v-for="(item, index) in dataSelectedUsers"
                :key="index"
                :label="item.realName"
                :value="item.id"
              >
                {{ item.realName }}
              </div>
            </div>
          </el-col>
        </el-row>
        <div style="text-align: center; padding-top: 1rem">
          <el-button
            type="primary"
            @click.native="submitSelectedUserList"
            style="margin-right: 1rem"
          >
            提交
          </el-button>
          <el-button @click.native="closeUserEditBox">取消</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  treeByProjectDeptId,
  getUserListByDepartmentId,
  getGroupList,
  getMenberUserList,
} from "@/api/crmedical/group/group";
export default {
  props: {
    single: {
      default: false, //是否为单选模式
    },
    projectId: {
      default: "", //项目id
    },
    remainUserListInside: {
      default: [], //选择的人员列表
    },
    required: {
      default: false,
    },
    disabled: {
      default: false,
    },
    message: {
      default: "请选择人员",
    },
    allUserList: {
      default: () => [],
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogLoading: false,
      errorMessage: "",
      userNames: "",
      //搜索条件
      realName: "",
      phone: "",
      treeLoading: false,
      moveLeftDisabled: true,
      moveRightDisabled: true,

      tempSelectedItemId: "",
      tempSelectedItemElement: "",

      dataForUserSelect: [],

      dataSelectedUsers: [],

      departmentTreeList: [],

      originUserList: [],

      groupTreeList: [],

      defaultProps: {
        children: "children",
        label: "title",
      },
      defaultProps_: {
        label: "name",
      },
    };
  },
  watch: {
    remainUserListInside: {
      handler(val) {
        console.log("remainUserListInside change==>", val);
        let cloneVal = this.deepClone(val);
        //传入的list的item中没有realName,从外面传入的allUserList中筛选
        if (cloneVal && cloneVal.length > 0 && !cloneVal[0]["realName"]) {
          this.dataSelectedUsers = this.allUserList.filter((ele) =>
            cloneVal.find((item) => item.id == ele.id)
          );
          //注意这里取的是 realNameAndPhone
          this.userNames = this.dataSelectedUsers
            .map((ele) => ele.realNameAndPhone)
            .toString();
        } else {
          //传入的list的item中有 realName，直接取值显示
          this.dataSelectedUsers = cloneVal;
          this.userNames = this.dataSelectedUsers
            .map((ele) => ele.realName)
            .toString();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async showDialog() {
      this.dialogLoading = true;
      try {
        const resDept = await treeByProjectDeptId({
          projectId: this.projectId,
        });
        this.departmentTreeList = resDept.data;
        const resGroup = await getGroupList({ projectId: this.projectId });
        this.groupTreeList = resGroup.data;
      } catch (err) {
        console.log("error==>", err);
      }
      this.dialogLoading = false;
      this.dialogVisible = true;
    },
    searchForm() {
      this.resetAllItem();
      getUserListByDepartmentId({
        projectId: this.projectId,
        realName: this.realName,
        phone: this.phone,
      }).then((res) => {
        res.data.forEach((ele, index) => {
          ele.realName = ele.realNameAndPhone;
        });
        this.originUserList = this.deepClone(res.data);
        this.dataForUserSelect = this.deepClone(res.data);
        this.initDataForSelect();
      });
    },
    selectedUserHandler(e) {
      this.resetAllItem();
      this.tempSelectedItemId = e.target.attributes.value.value;
      this.changeRightSelectedItemStyle(e);
      this.tempSelectedItemElement = e.target;
      this.moveLeftDisabled = false;
    },
    selectUserHandler(e) {
      // 单选模式
      this.resetAllItem();
      this.changeLeftSelectedItemStyle(e);
      this.tempSelectedItemId = e.target.attributes.value.value;
      this.tempSelectedItemElement = e.target;
      this.moveRightDisabled = false;
      if (this.single == true) {
        this.moveRightDisabled = this.dataSelectedUsers.length > 0;
        return;
      }
    },
    resetAllItem() {
      this.tempSelectedItemId = "";
      this.tempSelectedItemElement = "";
      this.moveRightDisabled = true;
      this.moveLeftDisabled = true;
      document.querySelectorAll('div[item="for-select"]').forEach((ele) => {
        ele.style.backgroundColor = "";
        ele.style.color = "";
      });
    },
    //切换选中项目的颜色
    changeLeftSelectedItemStyle(e) {
      e.target.style.backgroundColor = "#F5F7FA";
      e.target.style.color = "#409eff";
    },
    changeRightSelectedItemStyle(e) {
      document
        .querySelectorAll('div[name="item-for-selected"]')
        .forEach((ele) => {
          ele.style.backgroundColor = "";
          ele.style.color = "";
        });
      e.target.style.backgroundColor = "#F5F7FA";
      e.target.style.color = "#409eff";
    },
    moveRightAction() {
      let self = this;
      this.dataForUserSelect.forEach((ele, index) => {
        if (ele.id === self.tempSelectedItemElement.attributes.value.value) {
          this.dataForUserSelect.splice(index, 1);
        }
      });
      this.dataSelectedUsers.push({
        id: this.tempSelectedItemElement.attributes.value.value,
        realName: this.tempSelectedItemElement.attributes.label.value,
      });
      console.log("this.dataSelectedUsers==>", this.dataSelectedUsers);
      this.resetAllItem();
    },
    moveLeftAction() {
      let self = this;
      this.dataSelectedUsers.forEach((ele, index) => {
        if (ele.id === self.tempSelectedItemElement.attributes.value.value) {
          this.dataSelectedUsers.splice(index, 1);
        }
      });
      // console.log(this.dataForUserSelect);
      this.dataForUserSelect.push({
        id: this.tempSelectedItemElement.attributes.value.value,
        realName: this.tempSelectedItemElement.attributes.label.value,
      });

      console.log(this.dataForUserSelect);
      this.resetAllItem();
    },
    handleDeptNodeClick(data) {
      this.treeLoading = true;
      this.resetAllItem();
      let deptId = data.id;
      getUserListByDepartmentId({ deptId}).then((res) => {
        console.log(res);
        res.data.forEach((ele, index) => {
          ele.realName = ele.realNameAndPhone;
        });
        this.originUserList = this.deepClone(res.data);
        this.dataForUserSelect = this.deepClone(res.data);
        console.log(this.dataForUserSelect);
        this.initDataForSelect();
        this.treeLoading = false;
      });
      console.log(data);
    },
    handleGroupNodeClick(data) {
      this.treeLoading = true;
      this.resetAllItem();
      let groupId = data.id;
      //班组成员
      getMenberUserList({ groupId }).then((res) => {
        console.log(res);
        res.data.forEach((ele, index) => {
          ele.realName = ele.realNameAndPhone;
        });
        this.originUserList = this.deepClone(res.data);
        this.dataForUserSelect = this.deepClone(res.data);
        console.log(this.dataForUserSelect);
        this.initDataForSelect();
        this.treeLoading = false;
      });
    },
    initDataForSelect() {
      console.log("initDataForSelect");
      let arrListSelected = this.deepClone(this.dataSelectedUsers);
      let arrListForSelect = this.deepClone(this.dataForUserSelect);
      if (arrListSelected.length > 0) {
        arrListSelected.forEach((ele, i) => {
          arrListForSelect.forEach((element, index) => {
            if (element.id === ele.id) {
              arrListForSelect.splice(index, 1);
            }
          });
        });
      }

      this.dataForUserSelect = arrListForSelect;
    },
    closeUserEditBox() {
      this.dialogVisible = false;
      this.$emit("closeAction");
    },
    submitSelectedUserList() {
      this.userNames = this.dataSelectedUsers
        .map((ele) => ele.realName)
        .toString();
      this.$emit("update:remainUserListInside", this.dataSelectedUsers);
      if (this.required == true && this.dataSelectedUsers.length == 0) {
        this.errorMessage = this.message;
      }
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.pane {
  height: 400px;
  padding-left: 10px;
  background: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  text-align: left;
  overflow: scroll;
}
::v-deep .el-dialog {
  margin: 2vh auto 2vh !important;
}
::v-deep .el-tabs__content {
  height: 332px;
  overflow: scroll;
}
</style>>
